export const MAJOR_APPLIANCE_TYPE = 'MAJOR_APPLIANCE';
export const FREE_SHIPPING_THRESHOLD = 396;
export const MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY = 'DirectDelivery';
export const MCC_FULFILLMENT_METHOD_STH = 'ShipToHome';
export const MAP_TOOLTIP_CONTENT = `We've set this item's price lower than the manufacturer
 will let us advertise, so you'll have to add it to your cart to see our price. If you decide
  you don't want to purchase the item, you can remove it from your cart.`;
export const TOGGLE_PRODUCT_GROUP_SELECTION = 'TOGGLE_PRODUCT_GROUP_SELECTION';
export const TOGGLE_ALTERNATE_SELECTIONS = 'TOGGLE_ALTERNATE_SELECTIONS';
export const RESET_STATE = 'RESET_STATE';
export const SET_POD_INTERACTION = 'SET_POD_INTERACTION';
export const PROMOTIONAL_ADJUSTMENTS_UPDATED = 'PROMOTIONAL_ADJUSTMENTS_UPDATED';
export const ITEM_PROMO = 'ITEMPROMO';
export const ORDER_PROMO = 'ORDERPROMO';
export const SWAP_PRODUCT = 'SWAP_PRODUCT';
export const GEN_MERCH_PACKAGE = 'gen merch package';
export const KITCHEN_PACKAGE = 'kitchen package';
export const PACKAGE_GM = 'gm';
export const LIMITED_STOCK_THRESHOLD = 20;
export const BACKORDERED = 'Backordered';
export const LIMITED_STOCK = 'Limited Stock';
export const OUT_OF_STOCK = 'This product is out of stock';
export const QUANTITY_ERROR = 'QUANTITY_ERROR';
export const OUT_OF_STOCK_DETAILS = `One or more items in this bundle are out of stock. 
 To add bundle to cart please swap each item or `;
export const LIMITED_STOCK_DETAILS = 'Please reduce the quantity to proceed.';
export const SET_PRODUCT_SELECTED_QUANTITY = 'SET_PRODUCT_SELECTED_QUANTITY';
export const APPLIANCE_DEFAULT_AVAILABILITY_QUANTITY = 1;
export const STARTING_SELECTED_QUANTITY = 1;
export const REMOVE_OUT_OF_STOCK_ITEMS = 'REMOVE_OUT_OF_STOCK_ITEMS';
export const PROD_DOMAIN = typeof window !== 'undefined' && window?.location?.origin.includes('exchange')
  ? 'https://exchange.homedepot.com'
  : 'https://www.homedepot.com';
export const MAP_POLICY_VERBIAGE = {
  // eslint-disable-next-line
    showPriceInCart: 'We\'ve set an item\'s price lower than the manufacturer will let us advertise, so you\'ll have to add it to your cart to see our price. If you decide you don\'t want to purchase the item, you can remove it from your cart.',
  // eslint-disable-next-line
    showSpecialPriceIfAuth: 'The Home Depot price for one or more items is different from what the manufacturer allows us to advertise.'
};